@if (showFullScreen) {
  <button
    qai-button
    [shape]="'normal'"
    [kind]="'tertiary'"
    [size]="'large'"
    (click)="handleFullScreenClick()"
  >
    {{ fullScreenButtonText }}
    <qai-icon kind="expand" positionEnd />
  </button>
}

<button
  [ngClass]="{
    'next-button': canContinueNext && !isContinueButtonDisabled,
    'next-button-disabled': isContinueButtonDisabled,
    'no-response-detected': !canContinueNext && !isContinueButtonDisabled
  }"
  qai-button
  [shape]="'normal'"
  (click)="handleNextClick($event)"
  size="large"
  [kind]="canContinueNext ? 'primary' : 'tertiary'"
  [disabled]="isContinueButtonDisabled"
>
  {{'call.NEXT' | transloco}}
  <qai-icon
    [ngClass]="{ 'next-disable-icon': isContinueButtonDisabled }"
    kind="arrow-right"
    positionEnd
  />
</button>
